import ResetPasswordSuccess from "components/Organisms/login/forms/resetPassword/resetPasswordSuccess";

export default function resetPasswordSuccessPage() {
  return <ResetPasswordSuccess />;
}
